'use strict';

const { queryFirst, addClass, removeClass, queryAll, setAttribute, removeAttribute, hasClass } = require('../domUtil');
const { getJSON, appendToUrl, getNestedValue, setItemInLocalStorage } = require('../util');
const { shippingPreferences } = require('../templates').shippingPreferenceTemplates;
const { ispuSelectStyleMessageTmpl } = require('../templates').productDetail;
const { isShippingPreferencesViewEnabled } = require('../product/helper');
const {
    getChangeStoreLinkEl,
    getSelectedPreferenceEl,
    getShippingPreferencesContainerEl,
    getISPUradioButtonEl,
    getSelectedSizeEl,
    getShipToAddressradioButtonEl,
    getISPUPreferenceContentEl,
    addStoreNameClass,
    removeStoreNameClass,
    selectISPURadioButton,
    selectShipToRadioButton,
    getPreferedShippingPreference,
    disableISPURadioButton,
    disableShipToRadioButton,
    getShipToAddressContentEl,
    updateVisibilityOfLowInventoryMsg
} = require('./shippingPreference/shippingPreferenceHelper');
const { updateShipToInventoryMessages, updateISPUInventoryMessages, clearAllInventoryMessages, updateServiceResponseMessage, clearServiceResponseMessage } = require('./shippingPreference/inventoryMessaging');
const { injectISPUDeliveryMessage, clearISPUDeliveryMessage, showISPUDeliveryMessage, hideISPUDeliveryMessage } = require('./shippingPreference/ispuDeliveryMessaging');
const { getStoreDetailEl, addStoreDetail } = require('./shippingPreference/storeDetailHelper');
const { isEDDApplicable, injectEDDInfo, removeEDDInfo } = require('./pdpEdd');
const { EMPTY_STRING, HIDDEN_CLASS, NOT_AVAILABLE_STATUS, IN_STOCK_STATUS, SELECTED_CLASS } = require('../constants');
const { normalizeRadioGroup } = require('./accessibleRadioGroup');
const {
    DISABLED_CLASS,
    PRODUCT_DETAIL_CONTAINER_SELECTOR,
    SHIPPING_PREFERENCES_CONTAINER_SELECTOR,
    ISPU_SELECT_STYLE_MESSAGE_SELECTOR,
    ISPU_SERVICE_ERROR_ATTR_NAME,
    ISPU_RADIO_VALUE,
    SHIP_TO_RADIO_VALUE,
    SHIPPING_PREFERENCE_RADIO_BUTTON_SELECTOR,
    CHANGE_STORE_LINK_SELECTOR,
    SHIPPING_PREFERENCE_KEY,
    RADIO_BUTTON_LABEL_SELECTOR,
    STORE_DETAIL_SELECTOR,
    ISPU_INFO_MESSAGE_SELECTOR,
    PDP_CONTAINER_SELECTOR,
    AVAILABILITY_MSG_SELECTOR,
    NOT_AVAILABLE_CLASS,
    ISPU_SERVICE_BLOCKED,
    PRE_ORDER_CLASS,
    SHIP_TO_LOW_INVENTORY_CLASS,
    SET_CONTAINER_SELECTOR,
    AVAILABILITY_CHANGE_STORE_LINK_SELECTOR
} = require('./shippingPreference/constants');

const $body = $('body');
const $shippingPreferenceContainer = $(SHIPPING_PREFERENCES_CONTAINER_SELECTOR); // jQuery version, Used only for spinner

const shippingPreferencesConfig = getNestedValue(window, 'lillyUtils.shippingPreferencesConfig') || {};
const { isEnabled, messages, reasonCodes } = shippingPreferencesConfig;
const inventoryCache = {};

/**
 * Function to clear out any existing error/info messages
 * @param {HTMLElement} productContainer - Product container
 */
function clearAllMessages(productContainer) {
    clearServiceResponseMessage(productContainer);
    clearAllInventoryMessages(productContainer);
    clearISPUDeliveryMessage(productContainer);
}

/**
 * Function to reset radio button view and state
 * @param {HTMLElement} productContainer - Product container
 */
function resetPreferences(productContainer) {
    const shipToRadioButtonEl = getShipToAddressradioButtonEl(productContainer);
    if (shipToRadioButtonEl) {
        shipToRadioButtonEl.disabled = false;
        removeClass(shipToRadioButtonEl.nextElementSibling, DISABLED_CLASS);
    }
    const shipToAddressContentEl = getShipToAddressContentEl(productContainer);
    removeClass(shipToAddressContentEl, DISABLED_CLASS);

    const ispuRadioButtonEl = getISPUradioButtonEl(productContainer);
    if (ispuRadioButtonEl) {
        ispuRadioButtonEl.disabled = false;
        removeClass(ispuRadioButtonEl.nextElementSibling, DISABLED_CLASS);
    }
    const ispuPreferenceContentEl = getISPUPreferenceContentEl(productContainer);
    removeClass(ispuPreferenceContentEl, DISABLED_CLASS);
}

/**
 * Function to inject dynamically generated HTML into DOM
 * @param {HTMLElement} productContainerEl - Product container element
 * @param {boolean} preferISPU - A flag to select the ISPU radio on load
 * @param {Object} messages - map of messages
 */
function injectShippingPreferences(productContainerEl, preferISPU, messages) {
    const shippingPreferencesContainerEl = getShippingPreferencesContainerEl(productContainerEl);
    if (shippingPreferencesContainerEl) {
        const { preferenceIspuLabel, preferenceShipToAddressLabel, changeStoreLabel } = messages || {};
        const shippingPreferencesHTML = shippingPreferences(preferenceIspuLabel, ISPU_RADIO_VALUE, preferenceShipToAddressLabel, SHIP_TO_RADIO_VALUE, changeStoreLabel, preferISPU);
        $(shippingPreferencesContainerEl).html(shippingPreferencesHTML);
    }
}

/**
 * Function to handle successful inventory api response
 * @param {Object} response - Service response
 * @param {HTMLElement} productContainer - Product container element
 */
function handleISPUInventoryResponse(response, productContainer) {
    const { success } = response;

    clearAllMessages(productContainer);
    resetPreferences(productContainer);
    let storeDetailEl = getStoreDetailEl(productContainer);
    if (storeDetailEl) {
        storeDetailEl.textContent = EMPTY_STRING;
    }

    const ispuRadioButtonEl = getISPUradioButtonEl(productContainer);
    const shipToRadioButtonEl = getShipToAddressradioButtonEl(productContainer);
    const changeStoreLinkEl = getChangeStoreLinkEl(productContainer);
    const selectedSizeEl = getSelectedSizeEl(productContainer);

    removeClass(changeStoreLinkEl, ISPU_SERVICE_BLOCKED);

    window.ispuProductInventory = response;
    // Update the stock of sizes according to ISPU
    updateOutOfStockSizeForIspu();

    // Selected store inventory may differ from online stock, update roving tabindex to match
    const ispuSizeContainer = queryFirst('.pickup-size .size-container[role="radiogroup"]');
    if (ispuSizeContainer) {
        normalizeRadioGroup(ispuSizeContainer, '.size-btn[role="radio"]', {
            selectedClass: SELECTED_CLASS,
            notAvailableClass: NOT_AVAILABLE_CLASS
        });
    }

    renderAvailabilityMsg(response, selectedSizeEl, productContainer);
    if (success) {
        removeAttribute(ispuRadioButtonEl, ISPU_SERVICE_ERROR_ATTR_NAME);
        const { store, instorePickupStoreMsg } = response;

        // Add store details to DOM
        if (store) {
            addStoreDetail(store, productContainer);
        }
        injectISPUDeliveryMessage(instorePickupStoreMsg, productContainer);
        hideISPUDeliveryMessage(productContainer);

        if (ispuRadioButtonEl && ispuRadioButtonEl.checked) {
            // On Add to cart button click
            // it takes store-id from DIV element having 'store-name' class, making it ISPU add to cart.
            addStoreNameClass(productContainer);
        }

        // Reset change store link
        removeClass(changeStoreLinkEl, HIDDEN_CLASS);

        // Show store details, if the size is selected
        if (selectedSizeEl) {
            $(selectedSizeEl).trigger('click');
            removeClass(storeDetailEl, HIDDEN_CLASS);
            removeClass(changeStoreLinkEl, DISABLED_CLASS);
        } else {
            storeDetailEl = queryFirst(STORE_DETAIL_SELECTOR, document);
            addClass(storeDetailEl, HIDDEN_CLASS);
            removeClass(changeStoreLinkEl, DISABLED_CLASS);

            // Displaying 'Select size message'
            const ispuAvailabilityMessageEl = queryFirst(ISPU_SELECT_STYLE_MESSAGE_SELECTOR, productContainer);
            const { selectStylesMessage } = messages;
            if (ispuAvailabilityMessageEl && selectStylesMessage) {
                ispuAvailabilityMessageEl.innerHTML = !selectedSizeEl ? ispuSelectStyleMessageTmpl(selectStylesMessage) : EMPTY_STRING;
            }
        }

        queryAll('.select-store-input').forEach(el => {
            if (store && store.ID !== el.dataset.storeId) {
                el.checked = false;
            }
        });
    } else {
        setAttribute(ispuRadioButtonEl, ISPU_SERVICE_ERROR_ATTR_NAME, true);
        let wrapErrorMessage = false;
        disableISPURadioButton(productContainer, ispuRadioButtonEl, true);

        // Switch to 'Ship to address' radio button
        selectShipToRadioButton(productContainer, shipToRadioButtonEl, true);

        const { message, reasonCode } = response;
        let ispuPreferenceContentEl;
        let store;
        switch (reasonCode) {
            case reasonCodes.NO_STORES_FOUND:
                // Show change store link to select a new store, if nearest store is not found.
                removeClass(changeStoreLinkEl, HIDDEN_CLASS);
                break;
            case reasonCodes.STORES_SERVICE_DOWN:
                wrapErrorMessage = true;
                // Hide change store link
                addClass(changeStoreLinkEl, HIDDEN_CLASS);

                // Disable the ISPU section
                ispuPreferenceContentEl = getISPUPreferenceContentEl(productContainer);
                addClass(ispuPreferenceContentEl, DISABLED_CLASS);
                break;
            case reasonCodes.STORE_UNAVAILABLE:
                store = response.store;
                if (store) {
                    addStoreDetail(store, productContainer);
                }

                // Disable the ISPU section
                ispuPreferenceContentEl = getISPUPreferenceContentEl(productContainer);
                addClass(ispuPreferenceContentEl, DISABLED_CLASS);
                break;
            default:
                break;
        }

        // Show the info message why it got disabled
        if (message) {
            updateServiceResponseMessage(message, wrapErrorMessage, productContainer);
        }
    }
}

/**
 * Renders store availability message
 * @param {Object} response stores inventory response
 * @param {Object} selectedSize selected size
 */
function renderAvailabilityMsg(response, selectedSize, productContainer) {
    const msgBlock = queryFirst('.js-availability-msg', productContainer);
    if (!msgBlock) {
        return;
    }

    const selectedVariationId = selectedSize && selectedSize.dataset.variationId;

    const { variants, store } = response;
    let colorAvailable = false;
    let sizeAvailable = false;
    let sizeAvailableLimited = false;
    if (variants) {
        const keys = Object.keys(variants);
        colorAvailable = (keys && keys.find(key => variants[key].availabilityStatus === IN_STOCK_STATUS)) || false;
        sizeAvailable = selectedSize ? keys.find(key => key === selectedVariationId && variants[key].availabilityStatus === IN_STOCK_STATUS) : colorAvailable;
        sizeAvailableLimited = sizeAvailable ? keys.find(key => key === selectedVariationId && 'isLowInventory' in variants[key] && variants[key].isLowInventory) : colorAvailable;
    }

    let msgid = 'Unavailable';
    if (store) {
        if (colorAvailable) {
            msgid = sizeAvailable ? 'Available' : 'Sizeunavailable';
            if (sizeAvailable && sizeAvailableLimited) {
                msgid = 'Limited';
            }
        } else {
            msgid = 'Colorunavailable';
        }
    } else if (colorAvailable) {
        msgid = 'Available';
    }

    let storeMsg;
    const availabilityMsg = queryFirst('.msg-text', msgBlock);
    const storeBtn = queryFirst('.availability-change-store-link', msgBlock);
    availabilityMsg.textContent = msgBlock.dataset['msg' + msgid] + ' ';
    const { msgStore, msgAt, msgIn } = msgBlock.dataset;

    if (store) {
        storeMsg = store.name;
        availabilityMsg.textContent += msgAt;
        removeClass(storeBtn, 'm-no-border');
    } else {
        storeMsg = msgStore;
        availabilityMsg.textContent += msgIn;
        addClass(storeBtn, 'm-no-border');
    }

    if (queryFirst('.msg-store', msgBlock)) {
        queryFirst('.msg-store', msgBlock).textContent = storeMsg;
    }

    const resolvedStoreId = store?.ID
        || getNestedValue(window, 'lillyUtils.shippingPreferencesConfig.storeId')
        || getNestedValue(window, 'lillyUtils.shippingPreferencesConfig.preferredStoreId')
        || EMPTY_STRING;
    if (resolvedStoreId && resolvedStoreId !== 'null') {
        msgBlock.dataset.storeId = resolvedStoreId;
        removeClass(storeBtn, 'm-nostore');
    } else {
        addClass(storeBtn, 'm-nostore');
    }

    removeClass(msgBlock, 'd-none');

    if (msgid === 'Available' || msgid === 'Limited') {
        removeClass(availabilityMsg, 'unavailable');
        addClass(availabilityMsg, 'available');
        if (sizeAvailableLimited) {
            addClass(availabilityMsg, 'limited');
        }
    } else {
        addClass(availabilityMsg, 'unavailable');
        removeClass(availabilityMsg, 'available', 'limited');
    }
}

/**
 * Function to handle failure inventory api response
 * @param {Object} error - Service response
 * @param {HTMLElement} productContainer - Product container element
 */
function handleISPUInventoryError(error, productContainer) {
    window.ispuProductInventory = { variants: {} };
    clearAllMessages(productContainer);
    resetPreferences(productContainer);

    // Disable ISPU radio button and display error message
    disableISPURadioButton(productContainer, null, true);
    const { errorMessage } = messages;
    updateServiceResponseMessage(errorMessage, true, productContainer);
    const changeStoreLinkEl = getChangeStoreLinkEl(productContainer);
    addClass(changeStoreLinkEl, ISPU_SERVICE_BLOCKED);

    // Fallback to ship to address radio button
    selectShipToRadioButton(productContainer);
}

/**
 * Function to updateOutOfStockSize to instock if pickup instore is available for the size
 */
function updateOutOfStockSizeForIspu() {
    const { ispuProductInventory, productInfo } = window;
    const pdpContainer = queryFirst(PDP_CONTAINER_SELECTOR);
    let productId = null;
    let activeProductSetItem = null;
    if (hasClass(pdpContainer, 'product-set-detail')) {
        const ispuModalContainer = $('.sheet.modal[id*="pick-up-in-store-"]');
        const activeIspuModalContainer = ispuModalContainer.filter(':has(.active)');
        activeProductSetItem = activeIspuModalContainer.length ? activeIspuModalContainer[0].closest('.js-product-set-item') : null;
        productId = activeProductSetItem ? activeProductSetItem.dataset?.masterid : queryFirst('.js-product-set-item').dataset.masterid;
    } else {
        productId = pdpContainer.dataset.masterid;
    }
    const productContainer = activeProductSetItem || pdpContainer;
    const selectedColorElement = queryFirst('.color-attribute .swatch-circle.selected', productContainer);
    const selectedColorValue = selectedColorElement.dataset.attrValue;
    const variationGroup = getNestedValue(productInfo, '{0}.variants.{1}', productId, selectedColorValue);
    if (variationGroup) {
        queryAll('.pickup-size .size-container li').forEach(el => {
            const sizeBtn = queryFirst('button', el);
            const attributeValue = sizeBtn.dataset.attrValue;
            const getVariationJson = variationGroup.sizes[attributeValue];
            if (typeof getVariationJson !== 'undefined') {
                sizeBtn.dataset.variationid = getVariationJson.ID;
                const checkStoreAvailability = getVariationJson && getNestedValue(ispuProductInventory, 'variants.{0}.availabilityStatus', getVariationJson.ID);
                if (checkStoreAvailability !== NOT_AVAILABLE_STATUS) {
                    removeClass(sizeBtn, NOT_AVAILABLE_CLASS);
                } else {
                    addClass(sizeBtn, NOT_AVAILABLE_CLASS);
                }
            }
        });
    }
}
/**
 * Function to initialize events on shipping preferences section
 * @param {string?} storeId - storeId in from user session
 */
function initializeEvents() {
    /*
        Gets triggered twice
        #1 On color swatch selection
        #2 On selecting a store from the drawer
    */
    $body.on('product:updateStoreInventory', (event, data) => {
        const { productContainer, storeId } = data;
        const shippingPreferencesContainerEl = getShippingPreferencesContainerEl(productContainer);

        // Fetching selected swatch product id from dataset
        const selectedSwatchButton = queryFirst('.swatch-circle.selected', productContainer).closest('.color-attribute');
        if (selectedSwatchButton) {
            const { productId } = selectedSwatchButton.dataset;
            const actionUrl = getNestedValue(window, 'lillyUtils.shippingPreferencesConfig.actionUrl') || EMPTY_STRING;
            if (!actionUrl) return;

            // Build params for API call
            const params = { pid: productId };

            if (storeId && storeId !== 'null') {
                window.lillyUtils.shippingPreferencesConfig.storeId = params.storeID = storeId;
            } else {
                const sessionStoreId = getNestedValue(window, 'lillyUtils.shippingPreferencesConfig.storeId') || EMPTY_STRING;
                if (sessionStoreId && sessionStoreId !== 'null') {
                    params.storeID = sessionStoreId;
                }
            }
            const paramHash = productId + (params.storeID && params.storeID !== 'null' ? params.storeID : '');

            if (inventoryCache[paramHash]) {
                handleISPUInventoryResponse(inventoryCache[paramHash], productContainer);
                return;
            }
            const urlWithParams = appendToUrl(actionUrl, params);

            // Spinner for shipping preferences element
            const $spinner = $(shippingPreferencesContainerEl).spinner();
            $spinner.start();

            // Service call
            getJSON(
                urlWithParams,
                'GET',
                null,
                response => {
                    inventoryCache[paramHash] = response;
                    handleISPUInventoryResponse(response, productContainer);
                    $spinner.stop();
                },
                error => {
                    handleISPUInventoryError(error, productContainer);
                    $spinner.stop();
                }
            );
        }
    });

    $body.on('product:pdpSizeSelected', ($event, data) => {
        const { productContainer } = data;

        const storeDetailEl = getStoreDetailEl(productContainer);
        const changeStoreLinkEl = getChangeStoreLinkEl(productContainer);
        const selectedSizeEl = getSelectedSizeEl(productContainer);

        if (window.ispuProductInventory) {
            renderAvailabilityMsg(window.ispuProductInventory, selectedSizeEl, productContainer);
        }

        if (storeDetailEl) {
            removeClass(storeDetailEl, HIDDEN_CLASS);
            removeClass(changeStoreLinkEl, DISABLED_CLASS);
        } else {
            const storeServiceResponse = queryFirst(ISPU_INFO_MESSAGE_SELECTOR, document);
            addClass(storeServiceResponse, HIDDEN_CLASS);
        }
    });

    $body.on('product:inventoryStatus', function ($event, data) {
        const { shipToAddressAvailabilityStatus, inStorePickUpAvailabilityStatus, isStorePickUpLowInventory, inStorePickUpAvailabilityMessage, inStorePickUpLowStockMessage, productContainer } = data;

        const changeStoreLinkEl = getChangeStoreLinkEl(productContainer);
        const ispuRadioButtonEl = getISPUradioButtonEl(productContainer);
        const shipToRadioButtonEl = getShipToAddressradioButtonEl(productContainer);

        // Displaying Ship To EDD information
        if (isEDDApplicable(shipToAddressAvailabilityStatus)) {
            injectEDDInfo(productContainer);
        } else {
            removeEDDInfo(productContainer);
        }

        if (!ispuRadioButtonEl || !shipToRadioButtonEl) {
            return;
        }

        // Reset the radio button's state
        removeAttribute(ispuRadioButtonEl, 'disabled');
        removeAttribute(shipToRadioButtonEl, 'disabled');

        // Reset the change store link state
        removeClass(changeStoreLinkEl, HIDDEN_CLASS);
        removeClass(changeStoreLinkEl, DISABLED_CLASS);

        // Updating inventory messages
        updateShipToInventoryMessages(shipToAddressAvailabilityStatus, messages, productContainer);
        const ispuAvailabilityMessageEl = queryFirst(ISPU_SELECT_STYLE_MESSAGE_SELECTOR, productContainer);
        ispuAvailabilityMessageEl.innerHTML = EMPTY_STRING;
        if (!ispuRadioButtonEl.hasAttribute(ISPU_SERVICE_ERROR_ATTR_NAME)) {
            updateISPUInventoryMessages(inStorePickUpAvailabilityStatus, isStorePickUpLowInventory, inStorePickUpAvailabilityMessage, inStorePickUpLowStockMessage, messages, productContainer);
        }

        const preferenceValue = getPreferedShippingPreference();
        if (inStorePickUpAvailabilityStatus !== NOT_AVAILABLE_STATUS) {
            // ISPU is available
            showISPUDeliveryMessage(productContainer);

            // Enable ISPU content
            const ispuContentEl = getISPUPreferenceContentEl(productContainer);
            const ispuLabelEl = queryFirst(RADIO_BUTTON_LABEL_SELECTOR, ispuRadioButtonEl.parentElement);
            removeClass([ispuContentEl, ispuLabelEl], DISABLED_CLASS);
            ispuRadioButtonEl.disabled = false;

            const selectedPreferenceEl = getSelectedPreferenceEl(productContainer);

            // If previously user preference is ISPU and (if there is no radio button selected or selected radio is not ISPU)
            if (preferenceValue === ISPU_RADIO_VALUE && (!selectedPreferenceEl || selectedPreferenceEl !== ispuRadioButtonEl)) {
                selectISPURadioButton(productContainer, ispuRadioButtonEl);
            }
        } else {
            // ISPU is not available
            disableISPURadioButton(productContainer, ispuRadioButtonEl, true);
            hideISPUDeliveryMessage(productContainer);
        }

        if (shipToAddressAvailabilityStatus !== NOT_AVAILABLE_STATUS) {
            // Ship to address is available
            // Enable ship To content
            const shipToContentEl = getShipToAddressContentEl(productContainer);
            const shipToLabelEl = queryFirst(RADIO_BUTTON_LABEL_SELECTOR, shipToRadioButtonEl.parentElement);
            removeClass([shipToContentEl, shipToLabelEl], DISABLED_CLASS);
            shipToRadioButtonEl.disabled = false;

            const selectedPreferenceEl = getSelectedPreferenceEl(productContainer);

            // Fallback to shipTo if no radio button is selected (If ISPU is unavailable)
            if (!selectedPreferenceEl) {
                selectShipToRadioButton(productContainer, shipToRadioButtonEl);
            }
        } else {
            // Ship to address is not available
            disableShipToRadioButton(productContainer, shipToRadioButtonEl, true);

            // If ISPU is available
            if (inStorePickUpAvailabilityStatus !== NOT_AVAILABLE_STATUS) {
                selectISPURadioButton(productContainer, ispuRadioButtonEl);
            }
        }
    });

    // On shipping preference radio button 'change'
    $shippingPreferenceContainer.on('change', SHIPPING_PREFERENCE_RADIO_BUTTON_SELECTOR, event => {
        const radioButtonEl = event.target;
        const productContainer = radioButtonEl.closest(PRODUCT_DETAIL_CONTAINER_SELECTOR);

        // On Add to cart button click
        // it takes store-id from DIV element having 'store-name' class, making it ISPU add to cart.
        if (radioButtonEl.checked && radioButtonEl.value === ISPU_RADIO_VALUE) {
            setItemInLocalStorage(SHIPPING_PREFERENCE_KEY, ISPU_RADIO_VALUE);
            addStoreNameClass(productContainer);
        } else {
            setItemInLocalStorage(SHIPPING_PREFERENCE_KEY, SHIP_TO_RADIO_VALUE);
            removeStoreNameClass(productContainer);
        }
        updateVisibilityOfLowInventoryMsg(productContainer);
    });

    // On change-store link 'click'
    $shippingPreferenceContainer.on('click', CHANGE_STORE_LINK_SELECTOR, event => {
        const productContainerEl = event.target.closest(PRODUCT_DETAIL_CONTAINER_SELECTOR);

        // artificially call instore pickup dialog
        const $inStorePickupButton = $(productContainerEl).find('.btn-in-store-pickup');
        $inStorePickupButton.trigger('click');

        // return focus to initial link after modal close
        const $targetModal = $($inStorePickupButton.data('target'));
        const trigger = event.target;
        $targetModal.one('hidden.bs.modal', () => trigger.focus());
    });

    $(AVAILABILITY_CHANGE_STORE_LINK_SELECTOR).on('click', function (event) {
        event.preventDefault();

        const productContainerEl = this.closest(PRODUCT_DETAIL_CONTAINER_SELECTOR);
        // artificially call instore pickup dialog
        const inStorePickupButton = queryFirst('.btn-in-store-pickup', productContainerEl);
        inStorePickupButton.disabled = false;
        const productSetItem = inStorePickupButton.closest('.js-product-set-item') || null;
        if (productSetItem) {
            const { pid } = productContainerEl.dataset;
            inStorePickupButton.dataset.pid = pid;
            let ispuContainer = queryFirst('.sheet-page.pickup-in-store-content .pickup-in-store-container', productSetItem);
            if (ispuContainer) {
                ispuContainer.dataset.pid = pid;
            }
        }
        inStorePickupButton.click();

        const selectedColorElement = queryFirst('.color-attribute .swatch-circle.selected', productContainerEl);
        const selectedColorId = selectedColorElement.dataset.attrValue;
        const selectedColorName = selectedColorElement.dataset.attrDisplayvalue;
        const selectedColorLabel = queryFirst('.selected-swatch', productContainerEl).dataset.colorLabel;
        const masterId = productContainerEl.dataset.masterid;
        const productInfo = window.productInfo[masterId];
        const variantGroupData = productInfo.variants[selectedColorId];
        queryFirst('.pickup-price', productContainerEl).textContent = variantGroupData.formattedPrice.replace('.00', '');
        queryFirst('.pickup-color .selected-color', productContainerEl).textContent = selectedColorLabel + selectedColorName;
        $body.trigger('product:updateStoreInventory', { productContainer: productContainerEl });
        const sizeContainer = queryFirst('.size-container', productContainerEl);
        const selectedSize = queryFirst('.selected-size', productContainerEl);
        if (selectedSize) {
            selectedSize.innerHTML = sizeContainer.innerHTML;
            removeClass(selectedSize, HIDDEN_CLASS);

            // Update the stock of sizes according to ISPU
            updateOutOfStockSizeForIspu();

            // Ensure radiogroup is keyboard-accessible immediately, before async inventory API responds
            normalizeRadioGroup(selectedSize, '.size-btn[role="radio"]', {
                selectedClass: SELECTED_CLASS,
                notAvailableClass: NOT_AVAILABLE_CLASS
            });
        }

        const shipToRadioButtonEl = getShipToAddressradioButtonEl(productContainerEl);
        const ispuRadioButtonEl = getISPUradioButtonEl(productContainerEl);

        disableShipToRadioButton(productContainerEl, shipToRadioButtonEl, true);
        // Switch to 'Pick Up in store' radio button
        selectISPURadioButton(productContainerEl, ispuRadioButtonEl, true);

        const pickupAddToCartEl = queryFirst('.pickup-in-store-modal .add-to-cart');
        const pickupAddToCartBlock = queryFirst('.pickup-in-store-modal .js-sp-add-to-cart');
        pickupAddToCartEl.disabled = false;
        removeClass([pickupAddToCartEl, pickupAddToCartBlock], DISABLED_CLASS);

        // return focus to initial link after modal close
        const $targetModal = $(inStorePickupButton.dataset.target);
        const trigger = event.target;
        $targetModal.one('hidden.bs.modal', () => trigger.focus());
    });
}

// Injecting radio button and content dynamically
if (isShippingPreferencesViewEnabled()) {
    if (isEnabled && $shippingPreferenceContainer.length) {
        // Injects shipping preferences radio buttons
        const preferISPU = getPreferedShippingPreference() === ISPU_RADIO_VALUE;
        queryAll(PDP_CONTAINER_SELECTOR).forEach(el => {
            injectShippingPreferences(el, preferISPU, messages);
        });

        queryAll(SET_CONTAINER_SELECTOR).forEach(el => {
            injectShippingPreferences(el, preferISPU, messages);
        });

        // Updates data attribute on ISPU container to display select store view
        setAttribute(queryAll('.pickup-in-store-container'), 'data-select-store-view', true);

        // Hides Store Pick Up button exists below add to cart button
        addClass(queryAll('.pdp-in-store-inventory'), HIDDEN_CLASS);
    }

    // Attaches events on radio button changes, color swatch changes, size changes, change store link
    initializeEvents();
}
